// TODO: @config
/* eslint-disable no-restricted-syntax */

const toAbsoluteUrl = (url: string) =>
  url.indexOf('http') === 0 ? url : new URL(url, window.location.origin).href;

// environment variables
const reactAppApiUrl = window?.env?.REACT_APP_API_URL;
const reactAppMdhUrl = window?.env?.REACT_APP_MDH_URL;
const reactAppDocsUrl = window?.env?.REACT_APP_DOCS_URL;
const reactAppDataMatchingUrl = window?.env?.REACT_APP_DATA_MATCHING_URL;
const beamerProductIdEnv = window?.env?.REACT_APP_BEAMER_PRODUCT_ID;
const unleashClientKeyEnv = window?.env?.REACT_APP_UNLEASH_CLIENT_KEY;
const reactAppUnleashUrl = window?.env?.REACT_APP_UNLEASH_URL;
const reactAppAuthInfoUrl = window?.env?.REACT_APP_AUTH_INFO_URL;
const prometheusUsernameEnvvar = window?.env?.REACT_APP_PROMETHEUS_USERNAME;
const prometheusPasskeyEnvvar = window?.env?.REACT_APP_PROMETHEUS_PASSKEY;
const muiXLicenceKeyEnv = window?.env?.REACT_APP_MUI_X_LICENSE_KEY;
const reactAppAllowCustomApiUrl = window?.env?.REACT_APP_ALLOW_CUSTOM_API_URL;
const reactAppOtelTracesUrl = window?.env?.REACT_APP_OTEL_TRACES_URL;
const reactAppPrometheusUrl = window?.env?.REACT_APP_PROMETHEUS_URL;

// strings
export const docsUrl = toAbsoluteUrl(
  reactAppDocsUrl || 'https://rossum.app/api/docs/openapi'
);

export const allowCustomApiUrl = reactAppAllowCustomApiUrl || false;

export const customApiUrl = allowCustomApiUrl
  ? window.localStorage.getItem('customApiUrlValue')
  : undefined;

export const apiUrl = customApiUrl || reactAppApiUrl || 'http://localhost:5000';

export const mdhUrl = reactAppMdhUrl || 'http://localhost:8020';

export const absoluteApiUrl = toAbsoluteUrl(apiUrl);

export const emailDomainName = new URL(absoluteApiUrl).hostname;

export const apiUrlWithoutVersion = absoluteApiUrl.replace('/v1', '');

export const appAuthInfoUrl = reactAppAuthInfoUrl || '';

export const customerDomainEnabled = !!window?.env?.REACT_APP_CUSTOMER_DOMAIN;

export const beamerProductId = beamerProductIdEnv || 'MeHmBgBA43079';

export const beamerSelector = 'rossumBeamerSelector';

export const muiXLicenseKey =
  muiXLicenceKeyEnv ||
  '64795fb1875673f4099868f166ac3efdTz0xMzA4ODEsRT0xODE1MTc3NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=';

export const GTM_ID = 'GTM-ML6R7M5';

export const unleashClientKey = unleashClientKeyEnv || '';

export const unleashUrl = reactAppUnleashUrl
  ? toAbsoluteUrl(reactAppUnleashUrl)
  : null;

// TODO: @config - prometheus & MUI X license key values are not in configmap
export const prometheusUsername = prometheusUsernameEnvvar || 'frontend';

export const prometheusPasskey =
  prometheusPasskeyEnvvar || 'IrjomEfwavTapAuvReb2';

// booleans
export const shouldSentry = !!window?.env?.REACT_APP_SENTRY_ENABLED;

export const sentryDsn = window?.env?.REACT_APP_SENTRY_DSN || undefined;

export const otelTracesUrl = reactAppOtelTracesUrl
  ? toAbsoluteUrl(reactAppOtelTracesUrl)
  : null;

export const prometheusUrl = reactAppPrometheusUrl
  ? toAbsoluteUrl(reactAppPrometheusUrl)
  : null;

export const sentryEnvironment =
  window?.env?.REACT_APP_SENTRY_ENVIRONMENT || 'unknown';

export const currentCodeVersion =
  document.querySelector<HTMLMetaElement>('meta[name="GIT_COMMIT_SHA"]')
    ?.content || '';

export const isPathBasedEmbeddedMode = () =>
  window.location.pathname.startsWith('/embedded/');

export const isEmbedded = () => isPathBasedEmbeddedMode();

export const DEV_DEBUG_ENABLED =
  window.localStorage.getItem('devDebugEnabled') || false;

export const REACT_QUERY_DEVTOOLS_ENABLED =
  !!window.localStorage.getItem('reactQueryDevtoolsEnabled') || false;

export const dataMatchingUrl = reactAppDataMatchingUrl
  ? toAbsoluteUrl(reactAppDataMatchingUrl)
  : '';

export const customRossumAgentUrl = allowCustomApiUrl
  ? window.localStorage.getItem('customRossumAgentUrlValue')
  : undefined;

export const rossumAgentUrl =
  customRossumAgentUrl ||
  window?.env?.REACT_APP_ROSSUM_AGENT_URL ||
  'https://rossum-agent-api.tools.r8.lol';

export const customMrFabryAgentUrl = allowCustomApiUrl
  ? window.localStorage.getItem('customMrFabryAgentUrlValue')
  : undefined;

export const mrFabryAgentUrl =
  customMrFabryAgentUrl ||
  window?.env?.REACT_APP_MR_FABRY_AGENT_URL ||
  'https://mr-fabry-api.tools.r8.lol';

export const currentTagVersion =
  document.querySelector<HTMLMetaElement>('meta[name="GIT_TAG"]')?.content ||
  '';
